import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'storageUnit'
})
export class StorageUnitPipe implements PipeTransform {
  private units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

  transform(bytes: number, precision: number = 1): string {
    bytes = parseInt(bytes.toString());
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
      return '-';
    }

    let unitIndex = 0;
    while (bytes >= 1024 && unitIndex < this.units.length - 1) {
      bytes /= 1024;
      unitIndex++;
    }
    return `${bytes.toFixed(precision)} ${this.units[unitIndex]}`;
  }
}